var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00878906H513V341.991H0V-0.00878906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.191406H513V90.8914H0V0.191406ZM0.5 251.291H513V341.991H0.5V251.291Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.3 193.491L256 130.691L221.7 193.491H247.4V210.691H264.6V193.491H290.3Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.3 213.091C245.7 208.691 245.7 201.491 241.2 197.091L245.9 201.791C240.7 197.091 233.7 195.191 226.8 196.491L203.3 202.391C197.2 203.891 196.5 201.991 201.5 198.191L228.6 177.891C233.7 174.091 232.8 170.991 226.3 170.991H215.3C208.9 170.991 208.3 168.691 213.8 165.891L239.1 153.191C244.7 150.391 244.2 148.091 237.6 148.091H226.6C220.2 148.091 219.2 144.991 224.3 141.191L251.4 120.891C257 117.091 264.3 117.091 269.9 120.891L297 141.191C302.1 144.991 301.2 148.091 294.7 148.091H283.7C277.3 148.091 276.7 150.391 282.2 153.191L307.5 165.891C313.1 168.691 312.6 170.991 306 170.991H295C288.6 170.991 287.6 174.091 292.7 177.891L319.8 198.191C324.9 201.991 324.2 203.891 318 202.391L294.5 196.491C287.7 195.191 280.6 197.091 275.4 201.791L280.1 197.091C275.7 201.491 275.6 208.591 280 213.091L286.8 219.891C291.2 224.291 289.9 227.891 283.5 227.891H237.7C231.5 227.891 230 224.291 234.4 219.891C234.5 219.991 241.3 213.091 241.3 213.091Z",
    fill: "#14AF5A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00878906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLb);
export default __webpack_public_path__ + "static/media/LB.606e6e0975435119f1587396ea3d0f2c.svg";
export { ForwardRef as ReactComponent };